import React from 'react';
import type { HrefObj } from '@/common/goto';

enum pageType {
  channel = 'channel',
  promotion = 'promotion',
}

enum niePanZPMicroappBasename {
  channel = '/channel-service/activity/detail/commodity-pool-manage',
  promotion = '/activity-manage/detail/commodity-pool-manage',
}

interface detailLink {
  // 页面类型分为大促和频道
  pageType: pageType;
  niePanZPMicroappBasename: niePanZPMicroappBasename;
  toActivityDetail: any;
  toActivityDetailCommodityPool: any;
  toActivityCreate: any;
  toActivityEdit: any;
  toActivityDetailInfo: any;
  toNiePanZPDetail: any;
  toNiePanStartZP: any;
  toVenueDetail: any;
  toVenue: any;
  toZCActivity: any;
  toTiBaoVenueCreate: any;
  toTiBaoVenueEdit: any;
  toTiBaoQuaSetting: any;
  toTiBaoVenueSetting: any;
  toCreateZCActivity: any;
  toZCQualificationSetting: any;
  toZCResourceAllocation: any;
  toZCResourceDetail: any;
  toMaterialPoolSet: any;
  toMaterialPoolEdit: any;
  toMaterialManage: any;
  toUploadMaterial: any;
  toManualUploadMaterial: any;
  toEditMaterial: any;
  toNormalGoodlsPoolDetail: any;
}

function _fn() {
  console.warn('链接没有被赋值');
  return '';
}

function empty(): HrefObj {
  return {
    get: _fn,
    push: _fn,
    replace: _fn,
    newTab: _fn,
    reload: _fn,
  };
}

export default React.createContext<detailLink>({
  pageType: pageType.promotion,
  niePanZPMicroappBasename: niePanZPMicroappBasename.promotion,
  toActivityDetail: empty,
  toActivityDetailCommodityPool: empty,
  toActivityCreate: empty,
  toActivityEdit: empty,
  toActivityDetailInfo: empty,
  toNiePanZPDetail: empty,
  toNiePanStartZP: empty,
  toVenueDetail: empty,
  toVenue: empty,
  toTiBaoVenueCreate: empty,
  toTiBaoVenueEdit: empty,
  toTiBaoQuaSetting: empty,
  toTiBaoVenueSetting: empty,
  toZCActivity: empty,
  toCreateZCActivity: empty,
  toZCQualificationSetting: empty,
  toZCResourceAllocation: empty,
  toZCResourceDetail: empty,
  toMaterialPoolSet: empty,
  toMaterialPoolEdit: empty,
  toMaterialManage: empty,
  toUploadMaterial: empty,
  toManualUploadMaterial: empty,
  toEditMaterial: empty,
  toNormalGoodlsPoolDetail: empty,
});

export type { detailLink };

export { pageType, niePanZPMicroappBasename };
